import React, { useCallback, ChangeEvent, FC } from 'react'
import { useField, useFormikContext } from 'formik'
import { ConditionalTooltipCheckboxProps } from 'src/Components/Checkbox/ConditionalTooltipCheckbox'
import { ConditionalTooltipCheckbox } from 'src/Components'

interface FormikComponentProps extends ConditionalTooltipCheckboxProps {
  name: string
}

/**
 * The same component but for the formik form case
 */
export const ConditionalTooltipCheckboxFormik: FC<FormikComponentProps> = props => {
  const { name, onChange } = props
  const { setFieldValue } = useFormikContext()
  const [field] = useField(name)
  const isChecked = field?.value

  const handleCheckEvent = useCallback(
    (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      if (name) {
        setFieldValue(name, checked)
      } else {
        console.warn('Invalid fieldName', name)
      }

      onChange?.(event, checked)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setFieldValue, onChange]
  )

  return <ConditionalTooltipCheckbox {...props} onChange={handleCheckEvent} checked={isChecked} />
}

ConditionalTooltipCheckbox.displayName = 'ConditionalTooltipCheckbox'

export default ConditionalTooltipCheckbox
